import { gql } from 'graphql-request';
import { Customer } from 'src/shared/types';

export const habitatInsightsUploadQuery = gql`
    mutation addProjectSites($input: AddProjectSites!) {
        addProjectSites(input: $input)
    }
`;

export type HabitatInsightsUploadQueryResult = {
    addProjectSites: boolean;
};

export const createProjectInfoQuery = gql`
    mutation createProjectInfo($input: ProjectInfoInput!) {
        projects {
            createProjectInfo(projectInfo: $input)
        }
    }
`;

export const habitatInsightsProjectsQuery = gql`
    query getProjectList($customerId: String!) {
        customer(customerId: $customerId) {
            customerId
            customerName
            projects {
                customerName
                projectId
                projectName
                projectCode
                projectType
                projectEndDate
                area
                country
                createdAt
                creatorName
                updatedAt
                updaterName
                status
                features
                sites {
                    type
                    uploadedAt
                    uploadedBy
                    geometry {
                        coordinates
                    }
                    properties {
                        name
                        area
                        status
                        statusMessage
                        metrics {
                            metric
                            layers {
                                year
                                status
                                url
                            }
                        }
                    }
                }
            }
        }
    }
`;

export type HabitatInsightsProjectsQueryResult = {
    customer: Customer;
};
